import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export const GO = '[ROUTER] GO';
export const BACK = '[ROUTER] BACK';
export const FORWARD = '[ROUTER] FORWARD';

/** Action de redirection vers "path" */
export class Go implements Action {
    readonly type = GO;

    constructor(
        public payload: {
            path: unknown[];
            query?: object;
            extras?: NavigationExtras;
        }
    ) {}
}

/** Action de redirection vers "back" */
export class Back implements Action {
    readonly type = BACK;
}

/** Action de redirection vers "forward" */
export class Forward implements Action {
    readonly type = FORWARD;
}

export type Actions = Go | Back | Forward;
